import clsx from 'clsx';
import type { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '@/stores/hooks';
import { selectCodeBrand } from '@/stores/selectors';

/** Screens before OTP verify keep the Dice dark-blue panel (brand styling starts post-OTP). */
const PRE_OTP_PATHS = new Set(['/', '/age_smoker', '/pdpa', '/uniquecode', '/otp']);

/** Inner card — dark-blue for Dice / pre-OTP; purple for LBS post-OTP. */
export function SurveyBrownPanel({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  const { pathname } = useLocation();
  const codeBrand = useAppSelector(selectCodeBrand);
  const useLbsPurple = codeBrand === 'LBS' && !PRE_OTP_PATHS.has(pathname);

  return (
    <div
      className={clsx(
        'w-full rounded-lg p-4 text-[20px] sm:text-[22px] text-white/95 leading-snug drop-shadow-sm',
        useLbsPurple ? 'bg-[#2B0A3D]/75' : 'bg-[#010B1F]/75',
        className
      )}
    >
      {children}
    </div>
  );
}

/**
 * Horizontal alignment for panels on **flow** pages: cancels `SurveyBackgroundLayout`’s
 * `px-6` then applies `px-9`, matching Home’s `absolute inset-x-0 … px-9` strip width.
 */
export function SurveyBrownPanelInset({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) {
  return <div className={clsx('-mx-6 px-9', className)}>{children}</div>;
}
